import { useState } from "react";
import HBDataGrid from "./HBDataGrid";
import HB_DATA_LINK_ICON from "assets/images/icons/hb-data-link-icon.svg";

const HBDataLink = ({
  dataTable,
  vIdVal,
  testId,
  field,
  showErrors = false,
}) => {
  const [dataModalOpen, setDataModalOpen] = useState(false);

  const onClickDataLink = () => {
    setDataModalOpen(true);
  };

  const onCloseDataLink = () => {
    setDataModalOpen(false);
  };
  return (
    <>
      {dataModalOpen && (
        <HBDataGrid
          dataTable={dataTable}
          vIdVal={vIdVal}
          dataModalOpen={dataModalOpen}
          onCloseDataLink={onCloseDataLink}
          selectedHBTestId={testId}
          field={field}
          showErrors={showErrors}
        />
      )}
      <div className="display-flex" onClick={onClickDataLink}>
        <div className="grid-result-data">{"Data"}</div>
        <div className="data-grid-link-icon ml025">
          <img src={HB_DATA_LINK_ICON} alt="" />
        </div>
      </div>
    </>
  );
};

export default HBDataLink;
